import { AppReportTaskTypeTitlePageLayout, AppReportTaskTypeTitlePageType } from "../enums";

export interface IAppReportTaskTypeTitlePage {
    type: AppReportTaskTypeTitlePageType;
    layout: AppReportTaskTypeTitlePageLayout;
    name: string;
    description: string;
    image: string;
    imageName: string;
}

export class AppReportTaskTypeTitlePage implements IAppReportTaskTypeTitlePage {
    type: AppReportTaskTypeTitlePageType;
    layout: AppReportTaskTypeTitlePageLayout;
    name: string;
    description: string;
    image: string;
    imageName: string;

    constructor();
    constructor(obj: IAppReportTaskTypeTitlePage);
    constructor(obj?: any) {
        this.type = obj && obj.type || AppReportTaskTypeTitlePageType.CoverPage;
        this.layout = obj && obj.layout || AppReportTaskTypeTitlePageLayout.Layout1;
        this.name = obj && obj.name || "";
        this.description = obj && obj.description || "";
        this.image = obj && obj.image || "";
        this.imageName = obj && obj.imageName || "";
    }
}